import styled from 'styled-components';
import { Link as LinkRouter } from '@reach/router';
import breakpoints from '../breakpoints';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ccc;
  width: 90%;
  align-self: center;
  margin: 0 auto;
  padding: 70px 0;
  ${breakpoints('mobile', 'down')}{
    border-top: 1px solid #ccc;
    padding: 30px 0;
    margin-top: 20px;
  }
  ${breakpoints('mobile')}{
    border-top: none;
  }
`

export const Heading = styled.h3`
  font-family: "ToyotaType Semibold";
  font-weight: bold; 
  letter-spacing: 0.025em; 
  font-size: 26px; 
  line-height: 36px; 
  margin-bottom: 15px;
  text-align: center;
  width: 100%;
  ${breakpoints('tablet', 'down')}{
    font-size: 20px;
    line-height: 24px;
  }
`

export const PortfolioPicture = styled.div`
  & > img {
      width: 100%
  }
`

export const PortfolioTitle = styled.h3`
  font-family: "ToyotaType Bold"; 
  letter-spacing: 0.025em; 
  font-size: 26px; 
  line-height: 36px; 
  margin-bottom: 15px;
  ${breakpoints('tablet', 'down')}{
    font-size: 20px;
    line-height: 24px;
  }
`

export const AmountOfPortfolios = styled.span`
  display: inline-block;
  font-family: "ToyotaType Bold";
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.05em;
  padding-top: 25px;
`

export const PortfolioTitleJP = styled.h3`
  font-family: "ToyotaType Bold"; 
  letter-spacing: 0.025em; 
  font-size: 26px; 
  line-height: 36px; 
  padding-top: 15px;
  margin-bottom: 5px;
  ${breakpoints('tablet', 'down')}{
    font-size: 20px;
    line-height: 24px;
  }
`

export const AmountOfPortfoliosJP = styled.span`
  display: inline-block;
  font-family: "ToyotaType Bold";
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.05em;
  margin-bottom: 15px;
  
`

export const Description = styled.p`
  font-family: "ToyotaType Book"; 
  font-size: 14px; 
  line-height: 20px; 
  letter-spacing: 0.05em; 
`

export const Link = styled(LinkRouter)`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  color: #CC0000;
  text-decoration: underline;
  margin-top: auto;
  cursor: pointer;
  &:hover {
    color: #990000;
  }
`

export const BigSection = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  & > div {
    display: flex;
    align-self: stretch;
    flex: 0 0 calc(50% - 45px);
  }
  ${breakpoints('mobile', 'down')} {
    flex-direction: column;
    align-items: center;
  }
`

export const SmallSection = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  & > div {
    display: flex;
    align-self: stretch;
    flex: 0 0 calc(33% - 40px);
  }
  ${breakpoints('mobile', 'down')} {
    flex-direction: column;
  }
`

export const Portfolio = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
`

